import * as actions from "@/AppRedux/actions/admin/roomDetailConfig/roomDetailConfigType"

export const roomDetailsListRequest = (): actions.RoomDetailsListRequest => ({
  type: actions.ROOM_DETAILS_LIST_REQUEST,
})

export const roomDetailsGetRequest = (
  roomCode: string,
): actions.RoomDetailsGetRequest => ({
  type: actions.ROOM_DETAILS_GET_REQUEST,
  payload: { roomCode },
})

export const setRoomDetailsListSuccess = (
  payload: actions.RoomDetailsListResponse,
): actions.RoomDetailsListSuccess => ({
  type: actions.ROOM_DETAILS_LIST_SUCCESS,
  payload,
})

export const setRoomDetailsGetSuccess = (
  payload: actions.RoomData,
): actions.RoomDetailsGetSuccess => ({
  type: actions.ROOM_DETAILS_GET_SUCCESS,
  payload,
})

export const setRoomDetailsListFailure = (message: string): actions.RoomDetailsListFailed => ({
  type: actions.ROOM_DETAILS_LIST_FAILED,
  payload: message,
})

export const setRoomDetailsGetFailure = (message: string): actions.RoomDetailsGetFailed => ({
  type: actions.ROOM_DETAILS_GET_FAILED,
  payload: message,
})

export const roomDetailsUpdateRequest = (
  roomData: actions.RoomData,
): actions.RoomDetailsUpdateRequest => ({
  type: actions.ROOM_DETAILS_UPDATE_REQUEST,
  payload: roomData,
})

export const setRoomDetailsUpdateSuccess = (): actions.RoomDetailsUpdateSuccess => ({
  type: actions.ROOM_DETAILS_UPDATE_SUCCESS
})

export const setRoomDetailsUpdateFailure = (message: string): actions.RoomDetailsUpdateFailed => ({
  type: actions.ROOM_DETAILS_UPDATE_FAILED,
  payload: message,
})

export const roomDetailsUpdateSortOrderRequest = (
  items: actions.SortOrderItem[],
): actions.RoomDetailsUpdateSortOrderRequest => ({
  type: actions.ROOM_DETAILS_UPDATE_SORT_ORDER_REQUEST,
  payload: items,
})

export const setRoomDetailsUpdateSortOrderSuccess = (): actions.RoomDetailsUpdateSortOrderSuccess => ({
  type: actions.ROOM_DETAILS_UPDATE_SORT_ORDER_SUCCESS,
})

export const setRoomDetailsUpdateSortOrderFailure = (message: string): actions.RoomDetailsUpdateSortOrderFailed => ({
  type: actions.ROOM_DETAILS_UPDATE_SORT_ORDER_FAILED,
  payload: message,
})

export const clearRoomDetailsProcess = (): actions.RoomDetailsProcessClear => ({
  type: actions.ROOM_DETAILS_PROCESS_CLEAR,
})
